<a href="#main-content" class="skip-link text-2xl z-5 no-underline" (click)="skipToContent($event,'main-content')">Skip to content</a>
<main class="grid min-h-screen flex-column bg-slate-200 min-h-screen w-12 m-auto align-items-center">
    <app-tunnel-header class="col-12 p-0"></app-tunnel-header>
    <div class="col-12 flex-auto max-w-custom m-auto" id="main-content" tabindex="-1">
        <ng-content></ng-content>
    </div>
    <app-footer class="col-12 p-0 mt-4 max-w-custom "></app-footer>
</main>
<app-loader></app-loader>

